import BaseField from "./BaseField";

export class PlainTextField extends BaseField{
    constructor(props) {
        super(props);
    }

    renderText(){
        return {
            __html: this.props.Text
        }
    }

    render() {
        return (
            <div id={this.props.id} className={this.props.Columns}>
                <div className="field mb-4 mb-md-5 text__plain">
                    <p dangerouslySetInnerHTML={this.renderText()}>
                    </p>
                </div>
            </div>
        )
    }
}
export default PlainTextField;